<div class="edit-config-form">
  <h5 class="edit-config-title">
    <i class="icon-grid"></i> {{ 'forms.buttons.change_configuration' | translate }}
  </h5>

  <!-- Loading state -->
  <div *ngIf="loading" class="text-center py-4">
    <div class="spinner-border text-primary" role="status"></div>
  </div>

  <!-- No matrix -->
  <div *ngIf="!loading && (!matrixData || columns.length === 0)" class="text-muted py-3">
    {{ 'tables.no_results' | translate }}
  </div>

  <!-- Matrix content -->
  <div *ngIf="!loading && matrixData && columns.length > 0">
    <!-- Current config info -->
    <div class="current-config mb-3">
      <span class="current-config-label">{{ 'inputs.duration' | translate }}:</span>
      <span class="current-config-value">{{ orderData?.duration }} {{ 'inputs.month' | translate }}</span>
      <span class="current-config-sep">|</span>
      <span class="current-config-label">{{ 'inputs.yearly_kms' | translate }}:</span>
      <span class="current-config-value">{{ orderData?.yearly_kms | formatNumberPipe3 }} km</span>
      <span class="current-config-sep">|</span>
      <span class="current-config-label">{{ 'inputs.monthly_fee' | translate }}:</span>
      <span class="current-config-value">{{ orderData?.monthly_fee_total | formatNumberPipe }}<span class="text-sm">{{ orderData?.monthly_fee_total | formatNumberPipe2 }}</span></span>
    </div>

    <label class="form-label">{{ 'inputs.price_matrix' | translate }}</label>

    <table class="matriz">
      <thead>
        <tr>
          <th class="cell-no-border"></th>
          <th *ngFor="let col of columns">
            {{ col }} <span class="text-sm">{{ 'inputs.month' | translate }}</span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <th>
            {{ row | formatNumberPipe3 }}
            <span class="text-sm">{{ 'inputs.kilometers' | translate }}</span>
          </th>
          <td *ngFor="let col of columns">
            <button type="button"
              [disabled]="matrixDisplay[col]?.[row] == null"
              (click)="selectCell(col, row)"
              [ngClass]="{
                'selected': selectedCol === col && selectedRow === row,
                'current-cell': col === '' + orderData?.duration && row === '' + orderData?.yearly_kms
              }">
              <span *ngIf="matrixDisplay[col]?.[row] != null">
                {{ matrixDisplay[col]?.[row] | formatNumberPipe }}<span class="text-sm">{{ matrixDisplay[col]?.[row] | formatNumberPipe2 }}</span>
              </span>
              <span *ngIf="matrixDisplay[col]?.[row] == null"> - </span>
            </button>
          </td>
        </tr>
      </tbody>
    </table>

    <div class="mt-2 d-flex align-items-center justify-content-between">
      <div>
        <input class="form-check-input" type="checkbox" id="edit_config_iva"
          [checked]="showIva" (change)="onIvaToggle($event)" />
        <label class="form-check-label" for="edit_config_iva">
          {{ 'forms.buttons.iva_included' | translate }}
        </label>
      </div>
      <div *ngIf="selectedCol && selectedRow && canSubmit" class="selected-summary">
        <span class="text-muted">{{ 'inputs.duration' | translate }}: <strong>{{ selectedCol }} {{ 'inputs.month' | translate }}</strong></span>
        <span class="text-muted ms-3">{{ 'inputs.yearly_kms' | translate }}: <strong>{{ selectedRow | formatNumberPipe3 }} km</strong></span>
        <span *ngIf="selectedTotal != null" class="text-muted ms-3">{{ 'inputs.monthly_fee' | translate }}: <strong>{{ selectedTotal | formatNumberPipe }}<span class="text-sm">{{ selectedTotal | formatNumberPipe2 }}</span></strong></span>
      </div>
    </div>
  </div>
</div>
